import React, { useEffect, useState } from "react";
import Navbar from "../../components/layout/navbar";
import useRequest from "../../components/hooks/use-request";
import Button from "../../components/button";
import { Plus } from "lucide-react";
import AddPurchaseDialog from "../../components/purchase-order";
import { I_Requisition } from "../requisition/types";
import { I_Supplier } from "../suppliers/types";
import PurchaseTable from "./purchase-table";

interface ProfileData {
  username: string;
  email: string;
  phone: string;
  address: string;
  lastLogin: string;
}

interface MetricsData {
  totalOrders: number;
  ongoingOrders: number;
  paidOrders: number;
  unpaidOrders: number;
}

const PurchaseOrder = () => {
  const [profile, setProfile] = useState<ProfileData | null>(null);
  const [purchaseOrders, setPurchaseOrders] = useState<[]>([]);
  const [metrics, setMetrics] = useState<MetricsData | null>(null);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [requisition, setRequisition] = useState<I_Requisition[]>([]);
  const [suppliers, setSuppliers] = useState<I_Supplier[]>([]);
  const [inventory, setInventory] = useState<[]>([]);

  const userToken = localStorage.getItem("token");
  const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
  });
  const { makeRequest: getPurchaseOrders } = useRequest(
    "/purchase-order",
    "GET",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  const { makeRequest: getSuppliers } = useRequest("/suppliers", "GET", {
    Authorization: `Bearer ${userToken}`,
  });

  const {makeRequest: getInventory} = useRequest("/inventory", "GET", {
    Authorization: `Bearer ${userToken}`,
  })

  const { makeRequest: getPromotions } = useRequest(
    "/purchase-requisition",
    "GET",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );


  useEffect(() => {
    const fetchProfile = async () => {
      const [response] = await getProfile();
      if (response.status) {
        setProfile(response.data?.user);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      const [response] = await getPurchaseOrders();
      if (response.status) {
        setPurchaseOrders(response.data?.purchaseOrders);
      }
    };
    fetchOrders();
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      const [response] = await getInventory();
      if (response.status) {
        setInventory(response.data.inventory.docs);
      }
    };
    fetchOrders();
  }, []);

  useEffect(() => {
    const fetchRequisition = async () => {
      const [response] = await getPromotions();
      if (response.status) {
        setRequisition(response.data?.requisitions);
      }
    };
    fetchRequisition();
  }, []);

  useEffect(() => {
    const fetchSuppliers = async () => {
      const [response] = await getSuppliers();
      if (response.status) {
        setSuppliers(response.data?.suppliers?.docs);
      }
    };
    fetchSuppliers();
  }, []);

  function closePurchaseModal() {
    setPurchaseModal(false);
  }

  function openPurchaseModal() {
    setPurchaseModal(true);
  }

  

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar profile={profile as ProfileData} />
      <main className="flex-1 container mx-auto py-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
          <div className="mb-4 sm:mb-0">
            <h1 className="text-[30px] font-extrabold text-black">
              Purchase Orders
              
            </h1>
            <p className="text-[#676767] text-[18px] font-normal">
              Create and manage Purchase Orders for inventory restocking
            </p>
          </div>
          <div className="flex gap-2">
            <button className="rounded-full border p-2">Export</button>

            <Button
              size="lg"
              variant="primary"
              type="button"
              className="font-normal md:mt-0 mt-6"
              onClick={openPurchaseModal}
            >
              <Plus />
              Create Purchase Order
            </Button>
          </div>
        </div>
         {/* {metrics && <MetricsCard metrics={metrics} />}  */}

        <PurchaseTable data={purchaseOrders} /> 

      </main>
      <AddPurchaseDialog
        isVisible={purchaseModal}
        onClose={closePurchaseModal}
        requisition={requisition}
        suppliers={suppliers}
        inventory={inventory}
      />
    </div>
  );
};

export default PurchaseOrder;
